import React from "react";
import { ReactComponent as CancerLogo } from "../../Assets/Icons/CancerLogo.svg";
import {
  PageWrapper,
  TopBar,
  TopBarText,
  TopBarTitle,
  TopBarSubtitle,
  Container,
  PageHeading,
  PageSubHeading,
  ReleaseBlock,
  ReleaseHeader,
  ReleaseDate,
  VersionTag,
  Card,
  Section,
  SectionHeader,
  Tag,
  SectionTitle,
  List,
  ListItem,
} from "./index.styled";
import { releases } from "./release.config";

const ReleaseNotes = () => {
  return (
    <PageWrapper>
      <TopBar>
        <CancerLogo />
        <TopBarText>
          <TopBarTitle>P.A.T.H</TopBarTitle>
          <TopBarSubtitle>Partner Assessment Tool for Healthcare</TopBarSubtitle>
        </TopBarText>
      </TopBar>

      <Container>
        <PageHeading>Release Notes</PageHeading>
        <PageSubHeading>
          What's new, improved, and fixed across P.A.T.H releases.
        </PageSubHeading>

        {releases.map((release) => (
          <ReleaseBlock key={release.version}>
            <ReleaseHeader>
              <ReleaseDate>{release.date}</ReleaseDate>
              <VersionTag>{release.version}</VersionTag>
            </ReleaseHeader>

            <Card>
              {release.sections.map((section, idx) => (
                <Section key={idx}>
                  <SectionHeader>
                    <Tag type={section.tag}>{section.tag}</Tag>
                    <SectionTitle>{section.title}</SectionTitle>
                  </SectionHeader>
                  <List>
                    {section.items.map((item, i) => (
                      <ListItem key={i}>{item}</ListItem>
                    ))}
                  </List>
                </Section>
              ))}
            </Card>
          </ReleaseBlock>
        ))}
      </Container>
    </PageWrapper>
  );
};

export default ReleaseNotes;
